import logo from '../../assets/images/tc.png';

/** Original TronicsBase artwork; the viewport hides only its outer white frame. */
export default function BrandLogo({ compact = false }: { compact?: boolean }) {
  return <span className={`brandLogo${compact ? ' brandLogoCompact' : ''}`}>
    <img src={logo} alt="TronicsBase" width={834} height={316}/>
  </span>;
}
